<template>
  <div
    v-if="isLoaded"
    class="home"
  >
    <div class="card header" style="">
      <van-row>
        <van-col span="8">
          <router-link :to="{name:'Houses'}" class="link-item">
            <van-icon
              name="credit-card"
              size="36px"
              color="#fff"
              class-prefix="iconfont"
            />
            <span class="link-item__label">房产信息</span>
          </router-link>
        </van-col>
        <van-col span="8">
          <router-link to="/user">
            <van-image
              width="100"
              height="100"
              fit="cover"
              :src="require('@/assets/images/head.jpg')"
              class="avatar"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </router-link>
        </van-col>
        <van-col span="8">
          <router-link :to="{name: 'WebApplicationList'}" class="link-item" v-if="qxdm=='360983'">
            <van-icon
              name="category"
              size="32px"
              color="#fff"
              class-prefix="iconfont"
            />
            <span class="link-item__label">个人业务</span>
          </router-link>
          <router-link :to="{name: 'ApplicationList'}" class="link-item" v-else>
            <van-icon
              name="category"
              size="32px"
              color="#fff"
              class-prefix="iconfont"
            />
            <span class="link-item__label">个人业务</span>
          </router-link>
        </van-col>
      </van-row>
    </div>
    <div v-for="menuGroup in menuGroups" :key="menuGroup.id" class="card">
      <h2 class="card__title">
        {{ menuGroup.name }}
      </h2>
      <van-grid
        square
        clickable
      >
        <van-grid-item
          v-for="menu in menuGroup.weChatMenus"
          :key="menu.id"
          :text="menu.name"
          @click="handleGridItemClick(menu)"
        >
          <van-icon
            slot="icon"
            :name="menu.iconClass|iconName"
            :color="menu.iconColor|iconColor"
            size="36px"
            class-prefix="iconfont"
          />
          <span slot="text" class="grid-item__label">
            {{ menu.name }}
          </span>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>

<script>
import { getMenuGroupList } from '@/api/menu'
import { isExternal } from '@/utils/index'
import { Toast } from 'vant'
import { getSystemConfig } from '@/api/systemConfig.js'

export default {
  filters: {
    iconName(name) {
      return name || 'all'
    },
    iconColor(color) {
      return color || '#666'
    }
  },
  data() {
    return {
      isLoaded: false,
      menuGroups: [],
      qxdm: null
    }
  },
  computed: {
  },
  created() {
    // 显示加载进度
    Toast.loading({
      message: '加载中...',
      duration: 0
    })
    // 加载数据
    this.loadData().then(response => {
      // 加载成功，清除加载进度
      Toast.clear()
    }).catch(error => {
      // 加载失败，显示错误信息
      Toast.fail(error.message)
    })
    // 获取系统配置
    this.loadSystemConfig()
  },
  methods: {
    loadData() {
      return new Promise((resolve, reject) => {
        getMenuGroupList({
          isEnabled: true,
          eagerLoadingProperties: 'WeChatMenus'
        }).then(response => {
          const menuGroups = response.data
          menuGroups.forEach(menuGroup => {
            menuGroup.weChatMenus = menuGroup.weChatMenus
              .filter(menu => menu.isEnabled)
              .sort((a, b) => a.orderNo - b.orderNo)
          })
          this.menuGroups = menuGroups
          this.isLoaded = true
          resolve(menuGroups)
        }).catch(error => {
          reject(error)
        })
      })
    },
    handleGridItemClick(menu) {
      if (menu.url) {
        // switch (menu.code) {
        //   case 'application-shortcut':
        //     Toast('敬请期待')
        //     return
        //   case 'application-start':
        //     Toast('敬请期待')
        //     return
        // }
        if (isExternal(menu.url)) {
          window.location.href = menu.url
        } else {
          this.$router.push({ path: menu.url })
        }
      }
    },
    // 获取系统配置（区县代码）
    loadSystemConfig() {
      getSystemConfig({
        'key': 'DJXT_QXDM'
      }).then(response => {
        this.qxdm = response.data.value
      })
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  height: 100%;
  padding: 10px;
  background-color: #f7f7f7;
}
.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
}
.card {
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
  background-color: #fff;
  .card__title {
    color: #666666;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    font-weight: normal;
    text-indent: 20px;
    margin: 0px;
  }
  .van-grid{
    .van-grid-item{
      .van-grid-item__content{
        .grid-item__label{
          margin-top: 5px;
          line-height: 22px;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }
}
.card.header {
  text-align: center;
  background-color: #3bac6a;
  padding: 20px 0px;
  .link-item{
    display: block;
    width:36px;
    margin: 32px auto 0px;
    text-align: center;
    .link-item__label{
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
